export default __webpack_public_path__ + "static/media/6-23-19-Everythings_Right.da63bfc6.m4a";